import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { SelectCustom } from '../../../../../common/selectCustom'
import { CURRENCY } from '../../../../../utils/currency'
import { OTHER_DATA } from '../../../common/constant'
import { changeCriteria, selectCriteria } from '../../store/slice'
import classes from './index.module.scss'

export const Currency = () => {
  const dispatch = useDispatch()

  const activeCurrency = useSelector(selectCriteria([OTHER_DATA, 'currency']))

  const onChange = (e) => {
    dispatch(
      changeCriteria({
        path: [OTHER_DATA, 'currency'],
        data: e.value,
      }),
    )
  }

  return (
    <Element className="dFlex alignItemsCenter gap1" style={{ fontSize: 12 }}>
      <Element elementName="span" style={{ color: '#3A414B' }}>
        <Translate value="screening.CURRENCY" />:
      </Element>
      <Element>
        <SelectCustom
          activeItem={{ value: activeCurrency, label: activeCurrency }}
          data={Object.values(CURRENCY).map((i) => ({ value: i, label: i }))}
          chooseItem={onChange}
          className={classes.selectCurrency}
          style={{ fontSize: 12, backgroundColor: '#FFFFFF' }}
        />
      </Element>
    </Element>
  )
}
